import { render, staticRenderFns } from "./ReferentMqHabitat.vue?vue&type=template&id=49872368"
import script from "./ReferentMqHabitat.vue?vue&type=script&lang=js"
export * from "./ReferentMqHabitat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports